module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_circle-4a7ca32f6d376f9941eb141456209185.svg";